export interface Specification {
  value: number;
  viewValue: string;
}

export class NodeData {
  LaborGuideId: number;
  Name: string;
}

export class VinDetail {
  Name: string;
  Value: string;
}

export enum EPartType {
  Part = 0,
  Supply = 1,
  Battery = 2,
  Tire = 3
}
